export const ApplicationSearchConfig: Record<string, string>[] = [
  {
    key: "memberId",
    displayValue: "Member Id",
    regex: ""
  },
  {
    key: "jobId",
    displayValue: "Job Id",
    regex: ""
  },
  {
    key: "email",
    displayValue: "Email",
    regex: ""
  },
  {
    key: "phoneNumber",
    displayValue: "Phone number",
    regex: ""
  }
];
